<template>
    <tabs class="tabs text-left" ref="simulation-tabs"
            tabNavClasses="nav-fill flex-column flex-md-row nav-wrapper pt-0 pb-4"
            tabContentClasses="">

        <tab-pane class="mb-0" v-if="log.objectives">
            <span slot="title">
                {{ $t('logs.objectives') }}
            </span>

            <card class="mb-4" header-classes="border-0 pb-0">
                <h3 slot="header" class="mb-0">{{ $t('logs.objectives') }}</h3>
                <div class="tinymce" v-html="log.objectives"></div>
            </card>
        </tab-pane>

        <tab-pane class="mb-0" v-if="log.scenario">
            <span slot="title">
                {{ $t('logs.scenario') }}
            </span>

            <card class="mb-4" header-classes="border-0 pb-0">
                <h3 slot="header" class="mb-0">{{ $t('logs.scenario') }}</h3>
                <div class="tinymce" v-html="log.scenario"></div>
            </card>
        </tab-pane>

        <tab-pane class="mb-0" v-if="log.technical_means || log.zones || !initialParamsEmpty || log.other || log.flights || log.current_situation">
            <span slot="title">
                {{ $t('logs.initial-situation') }}
            </span>

            <card class="mb-4" header-classes="border-0 pb-0" v-if="log.technical_means">
                <h3 slot="header" class="mb-0">{{ $t('logs.technical-means') }}</h3>
                <div class="tinymce" v-html="log.technical_means"></div>
            </card>

            <card class="mb-4" header-classes="border-0 pb-0" v-if="log.zones">
                <h3 slot="header" class="mb-0">{{ $t('logs.zones') }}</h3>
                <div class="tinymce" v-html="log.zones"></div>
            </card>

            <card class="mb-4" header-classes="border-0 pb-0" v-if="!initialParamsEmpty">
                <ul class="list-group list-group-flush list my--3">

                    <li class="list-group-item px-0" v-if="log.runways">
                        <div class="row align-items-center">
                            <div class="col-md-4 text-uppercase font-weight-bold">{{ $t('logs.runways') }}</div>
                            <div class="col-md-8">{{ log.runways }}</div>
                        </div>
                    </li>

                    <li class="list-group-item px-0" v-if="log.qnh">
                        <div class="row align-items-center">
                            <div class="col-md-4 text-uppercase font-weight-bold">{{ $t('logs.qnh') }}</div>
                            <div class="col-md-8">{{ log.qnh }}</div>
                        </div>
                    </li>

                    <li class="list-group-item px-0" v-if="log.atis">
                        <div class="row align-items-center">
                            <div class="col-md-4 text-uppercase font-weight-bold">{{ $t('logs.atis') }}</div>
                            <div class="col-md-8">{{ log.atis }}</div>
                        </div>
                    </li>

                    <li class="list-group-item px-0" v-if="log.pilots_number">
                        <div class="row align-items-center">
                            <div class="col-md-4 text-uppercase font-weight-bold">{{ $t('logs.pilots-number') }}</div>
                            <div class="col-md-8">{{ log.pilots_number }}</div>
                        </div>
                    </li>

                </ul>
            </card>

            <card class="mb-4" header-classes="border-0 pb-0" v-if="log.other">
                <div class="tinymce" v-html="log.other"></div>
            </card>

            <card class="mb-4" header-classes="border-0 pb-0" v-if="log.flights">
                <h3 slot="header" class="mb-0">{{ $t('logs.flights') }}</h3>
                <div class="tinymce" v-html="log.flights"></div>
            </card>

            <card class="mb-4" header-classes="border-0 pb-0" v-if="log.current_situation">
                <h3 slot="header" class="mb-0">{{ $t('logs.current-situation') }}</h3>
                <div class="tinymce" v-html="log.current_situation"></div>
            </card>
        </tab-pane>

    </tabs>
</template>

<script>
    export default {

        props: {

            log: {
                type: Object,
                required: true
            },
        },

        computed: {

            initialSituationEmpty() {
                return this.initialParamsEmpty
                    && (this.log.flights || this.log.technical_means || this.log.current_situation
                        || this.log.zones || this.log.other) === null
            },

            initialParamsEmpty() {
                return (this.log.runways || this.log.qnh || this.log.atis || this.log.pilots_number) === null
            }
        },
    }
</script>
